import {
  Checkbox,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@data-delivery/d3s';
import { type UseFormReturn } from 'react-hook-form';
import { type AssignmentFormValues } from './form-schema';

interface FieldServicesSelectProps {
  form: UseFormReturn<AssignmentFormValues>;
  disabled?: boolean;
}

const SERVICE_OPTIONS = ['sftp1', 'sftp2', 'sftp3', 'sftp4'];

export function FieldServicesSelect({ form, disabled }: FieldServicesSelectProps) {
  const servicesSelected = form.watch('services') || [];
  return (
    <FormField
      control={form.control}
      name='services'
      render={() => (
        <FormItem>
          <FormLabel>Services</FormLabel>
          <FormControl>
            <div className='flex flex-wrap gap-3'>
              {SERVICE_OPTIONS.map(opt => {
                const checked = servicesSelected.includes(opt);
                return (
                  <label key={opt} className='flex items-center gap-2 text-xs'>
                    <Checkbox
                      checked={checked}
                      disabled={disabled}
                      onCheckedChange={val => {
                        const next = val
                          ? [...servicesSelected, opt]
                          : servicesSelected.filter(s => s !== opt);
                        form.setValue('services', next, { shouldValidate: true });
                      }}
                    />
                    <span className='capitalize'>{opt.replace('sftp', 'SFTP ')}</span>
                  </label>
                );
              })}
            </div>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
